<template>
  <v-menu
    v-model="menu"
    :close-on-content-click="false"
    :nudge-left="270"
  >
    <v-btn slot="activator" icon dark @click.stop="showMenu()">
      <v-icon color="black">more_vert</v-icon>
    </v-btn>
    <v-card>
      <v-list style="padding: 0">
        <v-list-tile @click="() => update({ soups: !soups })">
          <v-list-tile-action>
            <v-checkbox ref="checkbox" color="primary" :input-value="soups" />
          </v-list-tile-action>
          <v-list-tile-content>
            <span v-t="'editingContainer.soups'" />
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile>
          <v-list-tile-action>
            <v-icon>edit</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-text-field
              ref="focus"
              :label="$t('editingContainer.categoryName')"
              :value="categoryName"
              @input="name => update({ name })"
              @keyup.enter="menu = false"
              @keydown.native.esc="menu = false"
            />
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile>
          <v-list-tile-action>
            <v-icon>translate</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-text-field
              :label="$t('editingContainer.translation')"
              :value="categoryTranslation"
              @input="translation => update({ translation })"
              @keyup.enter="menu = false"
              @keydown.native.esc="menu = false"
            />
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile @click="deleteCategory()" @mouseover="deleteHover = true" @mouseout="deleteHover = false">
          <v-list-tile-action>
            <v-icon :color="deleteHover ? 'red' : null">{{ deleteHover ? 'delete_forever' : 'delete' }}</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <span v-t="'common.delete'" />
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-card>
  </v-menu>
</template>

<script>
export default {
  name: 'CategoryEditButton',
  props: {
    categoryName: {
      type: String,
      default: '',
    },
    categoryTranslation: {
      type: String,
      default: '',
    },
    soups: Boolean,
  },
  data() {
    return {
      menu: false,
      deleteHover: false,
    };
  },
  methods: {
    showMenu() {
      this.menu = true;
      this.focusInput();
    },
    focusInput() {
      setTimeout(() => {
        this.$refs.focus.focus();
      }, 100);
    },
    deleteCategory() {
      this.$emit('deleteCategory');
      this.menu = false;
    },
    update({
      name = this.categoryName,
      soups = this.soups,
      translation = this.categoryTranslation,
    }) {
      this.$emit('update', { name, soups, translation });
    },
  },
};
</script>
<style scoped>
.v-list >>> .v-list__tile {
  height: 68px
}
</style>
